export const Sizes = {
  ContainerBaseWidth: 1600,
  ContainerCompactWidth: 960,
  JumbotronRightWidth: 700,
  HeaderHeight: 90,
};
